/* -------------------------------------------------------------------------- */
/* 🧾 Billing Validation (Single Source of Truth)                              */
/* -------------------------------------------------------------------------- */

export const isBillingComplete = (company) => {
  if (!company) return false;

  return Boolean(
    company.billingEmail &&
    company.legalName &&
    company.address?.line1 &&
    company.address?.state &&
    company.address?.pincode &&
    company.address?.country
  );
};